import {rcAjax} from '../util';
import {GET_PARTNER_LIST} from './ActionTypes';

export function fetchBusinessPartner(dispatch, params) {
    return rcAjax('POST', '/api/v1/business_distributor?area=' + (params.area || ''), {}, params, data => {
        dispatch({type: GET_PARTNER_LIST, data: data.data});
    });
}